module.exports = __webpack_public_path__ + "img/blackened-pork-chops.9d00aa80.jpg";